import { Skeleton, SkeletonProps } from '@mui/material';

interface SkeletonListProps extends SkeletonProps {
  itemsCount: number;
}
export const SkeletonList: React.FC<SkeletonListProps> = ({ itemsCount, ...props }) => {
  return (
    <>
      {Array(itemsCount)
        .fill('')
        .map((_item, index) => (
          <Skeleton key={index} {...props} />
        ))}
    </>
  );
};
